export default "__VITE_ASSET__D6t3QTt3__"